<template>
  <div class="about__card">
    <div class="about__image"></div>
    <div>
      <div class="about__title">Hallo! Ich bin Mirjam Müller,</div>
      <div
        class="about__text"
      >mein Ziel ist es, Ihnen mit jeder Reise eine andere Facette von Genuss und Lebensfreude vorzustellen. Entdecken Sie mit mir die Vielfalt des edlen Rebensafts.</div>
      <router-link to="/about" class="about__link">
        <span>Über mich</span>
        <icon name="arrow-right-circle"></icon>
      </router-link>
    </div>
  </div>
</template>

<script>
import Icon from "../../../core/components/icon/Icon";

export default {
  name: "HomeAboutCard",
  components: {
    Icon
  }
};
</script>

<style scoped lang="scss">
.about__card {
  width: 864px;
  min-height: 256px;
  padding: 48px;
  border-radius: 16px;
  box-shadow: 0 8px 28px -8px rgba(13, 13, 13, 0.1),
    0 56px 100px -56px rgba(13, 13, 13, 0.2);
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  text-align: left;
  align-items: center;
  margin: 48px;
}

.about__image {
  min-width: 160px;
  min-height: 160px;
  max-width: 160px;
  max-height: 160px;
  background: url("../../../assets/img/mirjam-portrait-small.jpg");
  background-size: cover;
  border-radius: 50%;
  margin-right: 48px;
}

.about__title {
  //font-family: SoleilSb;
  font-family: Lato;
  font-weight: 700;
  font-size: 18px;
  //font-weight: 500;
  line-height: 23px;
  letter-spacing: 0.23px;
  color: #0d0d0d;
  margin-top: 12px;
  margin-bottom: 8px;
}

.about__text {
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  //font-weight: 300;
  font-size: 18px;
  letter-spacing: 0.23px;
  color: #4d4d4d;
  margin-right: 80px;
  margin-bottom: 18px;
  line-height: 23px;
}

.about__link {
  //font-family: SoleilSb;
  font-family: Lato;
  font-weight: 700;
  //font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  letter-spacing: 0.23px;
  color: #3787d9;
  cursor: pointer;
  text-decoration: none;

  > span {
    margin-right: 8px;
  }
}

@media (max-width: 1023px) {
  .about__text {
    margin-right: 48px;
  }
}

@media (max-width: 767px) {
  .about__card {
    width: 100%;
    padding: 32px 24px 28px;
    flex-direction: column;
    text-align: left;
    align-items: center;
    margin: 24px;
  }

  .about__image {
    min-width: 120px;
    min-height: 120px;
    max-width: 120px;
    max-height: 120px;
    margin-right: 0;
  }

  .about__title {
    text-align: center;
    margin-top: 24px;
  }

  .about__text {
    text-align: center;
    margin-right: 0;
  }

  .about__link {
    justify-content: center;
  }
}
</style>
